module.exports = __webpack_public_path__ + "static/media/flecha_right.c340942e.svg";